// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"573":"7e2f0774","612":"8d7033d3"}[chunkId] + ".chunk.js";
};